import tw, { css } from 'twin.macro'
import type { TTextInputProps } from './interface'

/* Label style */

export const StyledLabel = tw`
  px-6
`

export const getInputStyle = (isError: TTextInputProps['isError']) => isError && tw`border-red-500`

export const StyledInput = [
  tw`
    font-body
    rounded-3xl 
    px-6 
    h-12
    focus:outline-none
    border-none
  `,
  css`
    &.focus-ring {
      ${tw`border-black`}
    }
  `,
]
